const { ethers, utils, Signer } = require('ethers');
const { keccak256, toUtf8Bytes } = utils;

const _RAGE_QUIT_PACKET_TYPEHASH = keccak256(
    toUtf8Bytes('RageQuitAuth(bytes32 rageQuitParamsHash,uint256 deadline,uint256 nonce)')
);

const ZERO = ethers.BigNumber.from('0');
const ONE_GWEI = utils.parseUnits('1', 'gwei');
const ONE_ETHER = utils.parseUnits('1', 'ether');
const CHAIN_ID = {
	MAINNET: 1,
	GOERLI: 5,
	ROPSTEN: 3
};

const mainnetStakehouseAddresses = {
	TRANSACTION_ROUTER : "0x03F4310bfE3968934bC11DfA17B8DF809D7DEA80",
	ACCOUNT_MANAGER : "0xDd6E67942a9566A70446f7400a21240C5f71377C",
	SAVETH_REGISTRY : "0x88E6c7072B867F9546a232548a5D3271986B3C0c",
	SAVETH_MANAGER : "0x9CbC2Bf747510731eE3A38bf209a299261038369",
	SAVETH_BATCH_TX : "0x1D1f35aA28Ac454DA4b11b89971F5F8E6B207d37",
	SLOT_SETTLEMENT_REGISTRY : "0xC01DC3c7F83B12CFdF6C0AAa09c880EB45c48569",
	DETH : "0x3d1E5Cf16077F349e999d6b21A4f646e83Cd90c5",
	SAVETH_INDEX_NAMING_REGISTRY : "0x4C1fD37b47AFb6a31c14CC16253891c95740862F",
	SAFE_BOX : "0x8035a7Ab484D57A5a82469e0D6a38b2c942afBef",
	STAKEHOUSE_UNIVERSE : "0xC6306C52ea0405D3630249f202751aE3043056bd",
	HOUSE_RAGE_QUIT_ADAPTOR: ""
};

const goerliStakehouseAddresses = {
	TRANSACTION_ROUTER : "0xc4b44383C15E4afeD9845393b215a75D44D3d24B",
	ACCOUNT_MANAGER : "0x952295078A226bF40c8cb076C16E0e7229F77B28",
	SAVETH_REGISTRY : "0x3BE1e832D82525DbF76292433Ee70cA8080e41d9",
	SAVETH_MANAGER : "0x9ef3bb02cada3e332bbaa27cd750541c5ffb5b03",
	SAVETH_BATCH_TX : "0x55fa81847C1b399CEFe890Ef4F7389e0E16a9C19",
	SLOT_SETTLEMENT_REGISTRY : "0x1a86d0FE29c57e19f340C5Af34dE82946F22eC5d",
	DETH : "0x506c2b850d519065a4005b04b9ceed946a64cb6f",
	SAVETH_INDEX_NAMING_REGISTRY : "0x22f1B1FEe9a901486993506519b8fE4C56F2d6Eb",
	SAFE_BOX : "0xFd989Ff9133Bd5bb8c20b5B707296272a9Fa2fBc",
	STAKEHOUSE_UNIVERSE : "0xC38ee0eCc213293757dC5a30Cf253D3f40726E4c",
	HOUSE_RAGE_QUIT_ADAPTOR: "0xbF1E3A3EC7cE7C472A31B906974a50B9c361c4eD",
	LSDN_FACTORY: "0xe9482a9b8f3ea7400d4b07c798287d94b036be5c",
	GIANT_SAVETH_POOL: "0xf498849ea5caedf73cf9198c5a2ef9db62443809",
	GIANT_FEES_AND_MEV_POOL: "0x7d8381afbada9ab3ec16de3f17ad0e3a2af58b79",
	GIANT_SAVETH_LP: "0x4c6fffda6b732b495c974fb284e9bb38b9f061c8",
	GIANT_FEES_AND_MEV_LP: "0x9849d1d86c4de0ee7440142174a749185ad9152c",
	SMART_WALLET_NAMING_REGISTRY: "0x31D01003bE62Ef03222CF54E8895931e91B8C2eE"
};

const ropstenStakehouseAddresses = {
	TRANSACTION_ROUTER : "0x0770F05a4d36FB6C45628f9bC4B23B2286b8294d",
	ACCOUNT_MANAGER : "0xfA871ed3CBB6f3fF887456aeD44b467Cf15D86B1",
	SAVETH_REGISTRY : "0xae8E85bc750d22f809e0a21f8DCfa9FB4150bCDC",
	SAVETH_MANAGER : "0xe12effddf7657534a6261a2b2ca38d64d642e354",
	SAVETH_BATCH_TX : "0x4760118f2b256E38802333f1f8bCe3A9Ca95a2E5",
	SLOT_SETTLEMENT_REGISTRY : "0x8448494305941aD2C7C3D8B7B98eadAF74f9C790",
	DETH : "0x4fbf43bc906faa0a7ea36e9f401fd81e73d1dc22",
	SAVETH_INDEX_NAMING_REGISTRY : "0x8954cF64b898F5b691319172348e85D2837c86aE",
	SAFE_BOX : "0x7DD37032D6F91170E7102aF8a5114500db46Cc8a",
	STAKEHOUSE_UNIVERSE : "0xb6E46AEaC72E2872ec440Af87365E460272BC7CF",
	HOUSE_RAGE_QUIT_ADAPTOR: "0x6AAfC37864F6Cf3384B7284324d2abCD56382D7E"
};

const mainnetStakehouseUrls = {
	SUBGRAPH_ENDPOINTS : "https://api.thegraph.com/subgraphs/name/stakehouse-dev/stakehouse-protocol",
	BEACON_AUTH_ENDPOINT : "https://router.joinstakehouse.com/beacon-chain-authenticator",
	CREDENTIAL_GENERATOR : "https://generator.joinstakehouse.com/bls",
	BLS_AUTH_ENDPOINT : "https://router.joinstakehouse.com/bls-authentication"
};

const goerliStakehouseUrls = {
	SUBGRAPH_ENDPOINTS : "https://api.thegraph.com/subgraphs/name/bswap-eng/stakehouse-protocol",
	BEACON_AUTH_ENDPOINT : "https://router-goerli.joinstakehouse.com/beacon-chain-authenticator",
	CREDENTIAL_GENERATOR : "https://generator-goerli.joinstakehouse.com/bls",
	BLS_AUTH_ENDPOINT : "https://router-goerli.joinstakehouse.com/bls-authentication",
	BATCH_BLS_AUTH_ENDPOINT : "https://router-goerli.joinstakehouse.com/batch-bls-authentication",
	LSD_SUBGRAPH_ENDPOINT: "https://api.thegraph.com/subgraphs/name/bsn-eng/liquid-staking-derivative",
	V1_LSD_SUBGRAPH_ENDPOINT: "https://api.thegraph.com/subgraphs/name/stakehouse-dev/lsd"
};

const ropstenStakehouseUrls = {
	SUBGRAPH_ENDPOINTS : "https://api.thegraph.com/subgraphs/name/vince0656/stakehouse-v2-subgraph",
	BEACON_AUTH_ENDPOINT : "https://router-ropsten.joinstakehouse.com/beacon-chain-authenticator",
	CREDENTIAL_GENERATOR : "https://generator-ropsten.joinstakehouse.com/bls",
	BLS_AUTH_ENDPOINT : "https://router-ropsten.joinstakehouse.com/bls-authentication"
};

const mainnetCIPConstants = {
	DKG_PUBLIC_KEY : "04AB7C593DBC1C38F40B25A10FEE2A16845E6459DE0529DE2C9ADF821E9F230F6E63F6649CB062D5380776991E6E4452B663AF299765D5D70232774EC456DF0BCB",
	CIP_SUBGRAPH_ENDPOINT: "https://api.thegraph.com/subgraphs/name/stakehouse-dev/common-interest-protocol"
};

const goerliCIPConstants = {
	DKG_PUBLIC_KEY : "048FF084FD4C093AEC99743B6B60C4556595C61E7E2E4B08708443A25368DAEB650B7D1C0C8D4EC225E242037F72519F3A51054E89095146C87E8AE37FA535D0E2",
	CIP_SUBGRAPH_ENDPOINT: "https://api.thegraph.com/subgraphs/name/bsn-eng/common-interest-protocol"
};

const ropstenCIPConstants = {
	DKG_PUBLIC_KEY : "04C2362EAF96DF08904738A69AA16467A5CC6D22F556A6B32CB835DBDD812365662DCF754FE15876A853C9A23E8C640906FBC8EB8F20236338DA15907A5183CC2B",
	CIP_SUBGRAPH_ENDPOINT: "https://api.thegraph.com/subgraphs/name/justinzal/ropstencip"
};

const goerliBLSCredentialGeneratorConstants = {
	WITHDRAWAL_CREDENTIALS : "010000000000000000000000952295078a226bf40c8cb076c16e0e7229f77b28",
	FORK_VERSION : "00001020",
	NETWORK_NAME : "prater",
	CLI_VERSION : "2.2.0"
};

const mainnetBLSCredentialGeneratorConstants = {
	WITHDRAWAL_CREDENTIALS : "010000000000000000000000dd6e67942a9566a70446f7400a21240c5f71377c",
	FORK_VERSION : "00000000",
	NETWORK_NAME : "mainnet",
	CLI_VERSION : "2.2.0"
};

const customErrors = {
	BLS_KEY_DEPOSITED: 'Error: Public key has made a deposit',
	INVALID_PAYLOAD: 'Error: Invalid payload data',
	INVALID_CHAIN: 'Error: Invalid beacon chain',
	NO_REPORT_SUPPLIED: 'Error: No beacon chain report supplied',
	NODE_VALIDATION_FAIL: 'Error: Failed to validate against multiple beacon nodes',
	INVALID_CREDENTIALS: 'Error: Invalid credentials',
	NO_DEPOSIT: 'Error: No ETH deposited',
	CORRUPTED_DEPOSIT_DATA: 'Error: Corrupted Deposit Data',
	CORRUPTED_KEYSTORE_DATA: 'Error: Corrupted Keystore Data',
	NO_DISASTER_RECOVERY: 'Error: No Disaster Recovery Submitted',
	NULL_OR_UNDEFINED_VALUE: 'Error: Null or Undefined Value Provided',
	STATUS_NOT_0: 'Error: Validator Status not 0. BLS Key already in use',
	STATUS_NOT_1: 'Error: Validator Status not 1. Make sure BLS initials are registered and not already in use for deposit',
	STATUS_NOT_2: 'Error: Validator Status not 2. Make sure deposit is complete and derivative tokens are not yet minted',
	STATUS_NOT_2_OR_3: 'Error: Validator Status not 2 or 3. Validator not active',
	STATUS_NOT_3: 'Error: Validator Status not 3. Validator has not minted derivatives',
	NO_BALANCE_INCREASE: 'Error: Validator balance has not increased',
	ETH_BALANCE_LT_32: 'Error: Active Balance found to be less than 32 ETH',
	DETH_BALANCE_LT_24: 'Error: dETH Balance found to be less than 24',
	SLOT_BALANCE_LT_4: 'Error: SLOT Balance found to be less than 4',
	SETH_BALANCE_LT_12: 'Error: sETH Balance found to be less than 12',
	COLLATERALIZED_SETH_BALANCE_LT_THRESHOLD: 'Error: Collateralized sETH Balance found to be less than sETH Redemption Threshold',
	COLLATERALIZED_KNOTS_NOT_ALLOWED: 'Error: Too Many Collateralized Owners.',
	COULD_NOT_AUTHENTICATE: 'Error: Could not authenticate report',
	INVALID_SIGNATURE_ARRAY_LENGTH: 'Error: Number of Report and Tokenholders must be at least 4',
	EXIT_EPOCH_NOT_REACHED: 'Error: The slashed KNOT has not reached Exit Epoch',
	INVALID_SIGNATURE_CONTENT: 'Error: The signature is invalid',
	INVALID_SIGNATURE_HOLDER: 'Error: The Signature Holder is invalid',
	NEED_TO_WAIT: 'Error: The KNOT needs to wait for about 18 days',
	ALREADY_SLASHED: 'Error: The KNOT is already slashed',
	CANNOT_BE_SLASHED: 'Error: The KNOT cannot be slashed',
	SIGNER_IS_NOT_USER: 'Error: Signer Address does not match User Address',
	NOT_THE_INDEX_OWNER: 'Error: The user is not the owner of the Index',
	INDEX_LENGTH_ZERO: 'Error: User Does Not Own Any savETH indexes',
	INCORRECT_KEYSTORE_PASSWORD: 'Error: Incorrect Keystore password provided',
	BLS_PUBLIC_KEY_MISMATCH: 'Error: The provided BLS Public Key does not match the derived BLS Public Key from the Keystore file',
	INVALID_BLS_KEYSTORE: 'Error: The BLS Keystore provided is invalid',
	INSUFFICIENT_VALID_PIECES: 'Error: The decryption request has insufficient valid pieces',
	INVALID_GUARDIAN: 'Error: The Guardian provided does not exist',
	INVALID_AES_PUBLIC_KEY: 'Error: The AES Public Key is invalid',
	INCORRECT_AES_KEYSTORE: 'Error: Incorrect decryption key',
	INCORRECT_STORAGE_PATH: 'Error: Storage path does not exist',
	ZERO_ADDRESS: 'Error: Cannot provide zero address',
	INVALID_SERVER: 'Error: Try connecting to valid server with signing enabled or use a private key',
	REPORT_SLASH: 'Error: Unreported balance found. Please report your balance',
	NOT_MULTIPLE_OF_GWEI: 'Error: The value is not a multiple of 1 Gwei',
	UNDEFINED_VALUE: 'Error: Received undefined value',
	DECRYPTION_REQUEST_EXISTS: 'Error: Valid application already present',
	SLASHED_KNOT: 'Error: The KNOT has been slashed',
	SLOT_BALANCE_LT_2: 'Error: Applicant SLOT balance less than 2',
	PAST_EPOCH: 'Error: Cannot submit expired report',
	PASSWORD_LT_8: 'Error: Password too short. Make sure password is at least 8 characters long',
	INSUFFICIENT_DEPOSIT_AMOUNT: 'Error: Amount too less. Please make sure to deposit at least 0.001 ETH',
	BANNED_BLS_PUBLIC_KEY: 'Error: BLS public key is banned in the LSD network',
	INSUFFICIENT_GIANT_SAVETH_POOL_BALANCE: 'Error: Giant savETH pool has insufficient balance. Try funding savETH or giant savETH pool',
	INSUFFICIENT_GIANT_STAKING_POOL_BALANCE: 'Error: Giant Fees and MEV pool has insufficient balance. Try funding Fees and MEV or giant Fees and MEV pool',
	INSUFFICIENT_BATCH_DEPOSIT: 'Error: Incorrect ETH amount provided',
	ARRAY_LENGTH_MISMATCH: 'Error: Incorrect array length'
};

const customWarnings = {
	STORAGE_WARNING: 'Warning: Credentials being generated without backup path specified, make sure you backup your credential file. Specify \"storage\" to stop this warning'
};

const signatureEnum = {
    ROUTER: 0,
    FREE_FLOATING_SLOT_OWNER: 0,
    SAVETH_INDEX_OWNER: 1,
    COLLATERALISDED_SLOT_OWNER: 2
};

const KNOT_BATCH_AMOUNT = '24';

const _extractChainID = async (signerOrProvider) => {

	if(!signerOrProvider) {
		throw "Invalid signer or provider instance";
	}

    if(Signer.isSigner(signerOrProvider)) {
        return signerOrProvider.getChainId();
    }
    
	const network = await signerOrProvider.getNetwork();
	if(!network) {
		throw "Invalid signer or provider instance";
	}

	return network.chainId;
};

const _extractBlockData = async (signerOrProvider) => {

	if(!signerOrProvider) {
		throw "Invalid signer or provider instance";
	}

	if(Signer.isSigner(signerOrProvider)) {
        return signerOrProvider.provider.getBlock();
    }

	const blockInfo = await signerOrProvider.getBlock();
	if(!blockInfo) {
		throw "Invalid signer or provider instance";
	}

	return blockInfo;
};

const _getChainSpecificConstants = (chainID) => {

	// mainnet chain
	if(chainID === 1) {
		return {
			stakehouseAddresses: mainnetStakehouseAddresses,
			stakehouseUrls: mainnetStakehouseUrls,
			cipConstants: mainnetCIPConstants,
			blsCredentialGeneratorConstants: mainnetBLSCredentialGeneratorConstants,
			customErrors: customErrors,
			customWarnings: customWarnings,
			signatureEnum: signatureEnum,
			KNOT_BATCH_AMOUNT: KNOT_BATCH_AMOUNT,
			_RAGE_QUIT_PACKET_TYPEHASH: _RAGE_QUIT_PACKET_TYPEHASH
		};
	}
	// ropsten chain
	else if(chainID === 3) {
		return {
			stakehouseAddresses: ropstenStakehouseAddresses,
			stakehouseUrls: ropstenStakehouseUrls,
			cipConstants: ropstenCIPConstants,
			customErrors: customErrors,
			customWarnings: customWarnings,
			signatureEnum: signatureEnum,
			KNOT_BATCH_AMOUNT: KNOT_BATCH_AMOUNT,
			_RAGE_QUIT_PACKET_TYPEHASH: _RAGE_QUIT_PACKET_TYPEHASH
		};
	}
	// goerli chain
	else if(chainID === 5) {
		return {
			stakehouseAddresses: goerliStakehouseAddresses,
			stakehouseUrls: goerliStakehouseUrls,
			cipConstants: goerliCIPConstants,
			blsCredentialGeneratorConstants: goerliBLSCredentialGeneratorConstants,
			customErrors: customErrors,
			customWarnings: customWarnings,
			signatureEnum: signatureEnum,
			KNOT_BATCH_AMOUNT: KNOT_BATCH_AMOUNT,
			_RAGE_QUIT_PACKET_TYPEHASH: _RAGE_QUIT_PACKET_TYPEHASH
		};
	}
};

const lifecycleStatuses = {
	UNBEGUN: 0,
	INITIALS_REGISTERED: 1,
	DEPOSIT_COMPLETED: 2,
	TOKENS_MINTED: 3,
	EXITED: 4
};

const cipStatuses = {
	REENCRYPTION_REQUIRED: 4,
	FULLY_SECURED: 1,
	RECOVERY_PENDING: 2,
	DOWNLOAD_READY: 3
};

module.exports = {
	_getChainSpecificConstants,
	_extractChainID,
	_extractBlockData,
	_RAGE_QUIT_PACKET_TYPEHASH,
	ZERO,
	ONE_GWEI,
	ONE_ETHER,
	CHAIN_ID,
	customErrors,
	customWarnings,
	signatureEnum,
	KNOT_BATCH_AMOUNT,
	cipStatuses,
	lifecycleStatuses,
};
